/* Copyright (c) 2016, Oracle and/or its affiliates. All rights reserved.*/
"use strict";

define('utils/service/rest',['ojs/ojcore', 'knockout', 'jquery', 'ojs/ojknockout'], function (oj, ko, $) {
  var TARGET_BLANK = "_blank";
  var textStatus, errorThrown;
  var conf = GLOBAL_CONFIG; //$.ajaxSetup({cache:false}); // No-Cache setting for Development TODO: Change to prop.key
  //HGBU REST Functions

  var hgbuRest = {
    ajax: function ajax(type, url, done, data, datatype, contentType, headers, sync, fail) {
      var async = true;

      if (sync && true == sync) {
        async = false;
      }

      $.ajax({
        xhrFields: function xhrFields() {
          withCredentials: async ? false : true;
        },
        //beforeSend : function ( xhr ) {
        //	xhr.setRequestHeader( 'sessionIDHeader', sessionStorage.getItem( 'sessionIDHeader' ) );
        //	xhr.setRequestHeader( 'at_hgbu', sessionStorage.at_hgbu );
        //},
        async: async,
        // crossDomain: async,
        type: type ? type : "GET",
        dataType: datatype,
        data: data,
        url: url,
        contentType: contentType
      }).done(function (jqXHR, textStatus) {
        done(jqXHR, textStatus);
      }).fail(function (jqXHR, textStatus) {
        if (fail) {
          fail(jqXHR, textStatus);
        } else {//                    //handle authentication error
          //                    if (401 == jqXHR.status) {
          //                        //session.clearUserSession();
          //                    } else {
          //                        //EXCEPTION( jqXHR.error() );
          //                    }
        }
      });
    },
    getJSON: function getJSON(url) {
      var jsonResponse = undefined;
      $.ajaxSetup({
        async: false
      });
      $.getJSON(url, function (response) {
        jsonResponse = response;
      });
      $.ajaxSetup({
        async: true
      });
      return jsonResponse;
    },
    promiseBuilder: function promiseBuilder(url, type, data) {
      return new Promise(function (resolve, reject) {
        $.ajax(url, {
          type: type,
          async: true,
          data: data,
          contentType: "application/json",
          success: function success(response) {
            console.log("inside promise", response);
            resolve(response);
          },
          error: function error(jqXHR, textStatus, errorThrown) {
            console.log(textStatus, errorThrown, jqXHR);
            reject(jqXHR);
          }
        });
      });
    },

    /**
     * Returns API URL after building it from provided config for the
     *  requested service.
     * @param {type} serviceName, Service name from Config.json. If passed null/undefined then first service definition from config.json will be returned.
     * @param {type} pathName, Resource name
     * @returns {String}, Returns url of the format http://llg00avj.uk.oracle.com:5000/api/v1/Orders/
     */
    buildServiceUrl: function buildServiceUrl(serviceName, pathName, context) {
      var serviceJson;
      var serviceContext;
      var serviceUrl = "";

      try {
        if (serviceName) {
          serviceJson = conf.service[serviceName];
        } else {
          serviceJson = conf.service[Object.keys(conf.service)[0]];
        }

        if (conf.useRelativePathForService) {
          serviceUrl = location.protocol + "//" + location.host + "/" + context + "/";
        } else {
          serviceUrl = serviceJson.protocol + "://" + serviceJson.host;

          if (serviceJson.port) {
            serviceUrl += ":" + serviceJson.port + "/" + context + "/";
          } else {
            serviceUrl += "/";
          }
        }

        if (serviceJson.context) {
          serviceContext = serviceJson.context; // if (serviceContext["api"]) {
          //     serviceUrl += serviceContext["api"] + "/";
          // }
          // if (serviceContext["orgName"]) {
          //     serviceUrl += serviceContext["orgName"] + "/";
          // }

          if (serviceJson.version) {
            serviceUrl += serviceJson.version + "/";
          }
        } //                                if (serviceJson.version){
        //                                    serviceUrl = serviceUrl + serviceJson.version + "/";
        //                                }


        if (pathName) {
          serviceUrl = serviceUrl + pathName + "";
        }
      } catch (e) {
        // log.error("Error in Building REST Service URL: " + e.message, "Service Name: ", serviceName, "Path name: ", pathName);
        console.log(e.message);
      }

      return serviceUrl;
    },
    fileExists: function fileExists(url) {
      var http = new XMLHttpRequest();
      http.open('HEAD', url, false);
      http.send();
      return http.status == 200;
    },
    dirtyFlag: function dirtyFlag(root, isInitiallyDirty) {
      var result = function result() {},
          _initialState = ko.observable(ko.toJSON(root)),
          _isInitiallyDirty = ko.observable(isInitiallyDirty);

      result.isDirty = ko.computed(function () {
        return _isInitiallyDirty() || _initialState() !== ko.toJSON(root);
      });

      result.reset = function () {
        _initialState(ko.toJSON(root));

        _isInitiallyDirty(false);
      };

      return result;
    },
    changeTracker: function changeTracker(objectToTrack, hashFunction) {
      hashFunction = hashFunction || ko.toJSON;
      var lastCleanState = ko.observable(hashFunction(objectToTrack));
      var result = {
        somethingHasChanged: ko.dependentObservable(function () {
          return hashFunction(objectToTrack) != lastCleanState();
        }),
        markCurrentStateAsClean: function markCurrentStateAsClean() {
          lastCleanState(hashFunction(objectToTrack));
        }
      };
      return function () {
        return result;
      };
    },
    openNewTab: function openNewTab(url) {
      window.open(url, TARGET_BLANK);
    },
    waitUntil: function waitUntil(isready, success, error, count, interval) {
      if (count === undefined) {
        count = 100;
      }

      if (interval === undefined) {
        interval = 500;
      }

      if (isready()) {
        success();
        return;
      } // The call back isn't ready. We need to wait for it


      setTimeout(function () {
        if (!count) {
          // We have run out of retries
          if (error !== undefined) {
            error();
          }
        } else {
          // Try again
          hgbuRest.waitUntil(isready, success, error, count - 1, interval);
        }
      }, interval);
    },
    fetchHeaders: function fetchHeaders(callback) {
      var request = new XMLHttpRequest();

      request.onreadystatechange = function () {
        if (request.readyState === 4) {
          if (callback && typeof callback === 'function') {
            callback(parseResponseHeaders(request.getAllResponseHeaders()));
          }
        }
      }; //
      // Re-request the same page (document.location)
      // We hope to get the same or similar response headers to those which 
      // Since we are only after the headers, a HEAD request may be sufficient.
      //


      request.open('HEAD', document.location, true);
      request.send(null);
    },
    setHeaders: function setHeaders(headerArray) {
      if (GLOBAL_CONFIG && GLOBAL_CONFIG.application) {
        if (GLOBAL_CONFIG.application.initHeader === true) {
          GLOBAL_CONFIG.require.config = {
            text: {
              onXhr: function onXhr(xhr, url) {
                //xhr.open() call, but before the xhr.send() call. Useful time to set headers.
                xhr.setRequestHeader("Accept", "text/javascript");
                $.each(headerArray, function (key, value) {
                  xhr.setRequestHeader(value.headerName, value.headerValue); //Setting custom header
                });
              },
              onXhrComplete: function onXhrComplete(xhr, url) {} //Called whenever an XHR has completed its work.

            }
          };
          requirejs.config(GLOBAL_CONFIG.require); // Set require paths again to include text.js config
        }
      }
    },
    sanitizeJSON: function sanitizeJSON(unsanitized) {
      return unsanitized.replace(/:\s*"([^"]*)"/g, function (match, p1) {
        return ': "' + p1.replace(/:/g, '@colon@') + '"';
      }).replace(/:\s*'([^']*)'/g, function (match, p1) {
        return ': "' + p1.replace(/:/g, '@colon@') + '"';
      }).replace(/(['"])?([a-z0-9A-Z_]+)(['"])?\s*:/g, '"$2": ').replace(/@colon@/g, ':');
    },
    generateUUID: function generateUUID() {
      // http://stackoverflow.com/a/8809472/1278540
      var d = new Date().getTime();

      if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        d += performance.now(); //use high-precision timer if available
      }

      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
      });
    },
    getHmacSha256HexEncoded: function getHmacSha256HexEncoded(message, secret) {
      return CryptoJS.HmacSHA256(message, secret);
    }
  }; //Capture and Log failed response.

  function failedResponse(XMLHttpRequest, textStatus, errorThrown) {
    Console.log("Status: " + textStatus + "Error: " + errorThrown);
  } // XmlHttpRequest's getAllResponseHeaders() method returns a string of response headers. This method parses that string into a user-friendly key/value pair object.


  function parseResponseHeaders(headerStr) {
    var headers = {};

    if (!headerStr) {
      return headers;
    }

    var headerPairs = headerStr.split("\r\n");

    for (var i = 0; i < headerPairs.length; i++) {
      var headerPair = headerPairs[i];
      var index = headerPair.indexOf(": ");

      if (index > 0) {
        var key = headerPair.substring(0, index);
        var val = headerPair.substring(index + 2);
        headers[key] = val;
      }
    }

    return headers;
  }

  return hgbuRest;
});
